import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback } from 'react';
import { Panel } from "react-resizable-panels";
import * as serverApi from '../apis/server-api';
import { FaPlus } from "react-icons/fa6";
import * as ListItemCreator from './list-items';
import { FaPlay } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import * as lastfm from '../apis/last-fm';
import AddToPlaylistPopup from './add-to-playlist-popup';

const SearchResults = forwardRef(({searchQuery, onLibraryUpdated, setCenterContent, isMobile}, ref) => {
    const [songs, setSongs] = useState([]);
    const [addSong, setAddSong] = useState({});
    const searchControllerRef = useRef(null);

    const performSearch = useCallback(async () => {
        if (searchControllerRef.current) {
            searchControllerRef.current.abort();
        }

        const controller = new AbortController();
        searchControllerRef.current = controller;

        setSongs([]);
        if (!searchQuery || !searchQuery.trim()) {
            return;
        }

        try {
            const tracks = await lastfm.searchLastFM(searchQuery, controller.signal);
            console.log(tracks);
            const results = [];

            for (const track of tracks) {
                if (controller.signal.aborted) {
                    return;
                }

                const info = await lastfm.getTrackInfo(track.name, track.artist, controller.signal);
                if (controller.signal.aborted) {
                    return;
                }

                const _songName = track.name;
                const _artistName = track.artist;
                const _mbid = track.mbid;
                let _albumName = info && info.album ? info.album.title : _songName;
                let _imageUrl = 'https://placehold.co/300x300?text=No+Image';
                if (info && info.album && info.album.image && info.album.image[3] && info.album.image[3]['#text']) {
                    _imageUrl = info.album.image[3]['#text'];
                }
                const _songUrl = track.url;
                results.push({title: _songName, artist: _artistName, artworkPath: _imageUrl, albumName: _albumName, isSearch: true});
                setSongs([...results]);
            }
        } catch (error) {
            if (error.name === 'CanceledError' || error.name === 'AbortError') {
                return;
            }
            console.error('Search failed:', error);
        }
    }, [searchQuery]);

    useImperativeHandle(ref, () => ({
        performSearch,
    }), [performSearch]);

    useEffect(() => {
        performSearch();
        return () => {
            if (searchControllerRef.current) {
                searchControllerRef.current.abort();
            }
        };
    }, [searchQuery, performSearch]);

    const addSongPlaylist = (song) => {
        setAddSong(song);
    };

    return(
        <>
        <AddToPlaylistPopup song={addSong} setSong={setAddSong} refreshLibrary={onLibraryUpdated}></AddToPlaylistPopup>
        <Panel defaultSize={40} minSize={'40%'} className="panel" style={{marginBottom: isMobile? '70px' : '0px'}}>
            <h2>Search Results</h2>
            <button className="CenterCloseButton" onClick={() => setCenterContent('none')}> <IoClose /> </button>
            
            {songs.length == 0 ? <p>Search something...</p> :  songs.map((song, idx) => <ListItemCreator.CreateSongItem key={`${song.title}-${song.artist}-${idx}`} song={song} playCallback={addSongPlaylist} />)}
        </Panel>
        </>
    )
})
export default SearchResults